import React from "react";
import Select from "react-select";

import selectStyles from './SiteSelectComp.module.css';

const SiteSelectComp = (props) => {
	const selectedSite = props.selectedSite != null ? props.selectedSite : null;
	const handleSite = props.handleSite != null ? props.handleSite : null;
	const options = props.options != null ? props.options : null;
	const defaultValue = props.defaultValue != null ? props.defaultValue : null;
	const styles = props.styles != null ? props.styles : null;

	/**
	 * Filter options based on client name and site name
	 */
	const filterOption = ({ label, value }, string) => {
		if (
			label.toLocaleLowerCase().includes(string.toLocaleLowerCase()) ||
			value.site_name.toLocaleLowerCase().includes(string.toLocaleLowerCase())
		)
			return true;

		// check if a group as the filter string as label
		const groupOptions = options.filter((group) =>
			group.label.toLocaleLowerCase().includes(string.toLocaleLowerCase())
		);

		if (groupOptions) {
			for (const groupOption of groupOptions) {
				// Check if current option is in group
				const option = groupOption.options.find((opt) => opt.value === value);
				if (option) return true;
			}
		}
		return false;
	};
	return (
		<Select
			defaultValue={defaultValue}
			options={options}
			onChange={handleSite}
			value={selectedSite}
			filterOption={filterOption}
			styles={styles}
			className={selectStyles.select}
		/>
	);
};

export default SiteSelectComp;
